import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Calendar } from '@pcln/date-picker';
import { withTheme } from 'styled-components';
import Icon from 'components/Icon';

class PricelineDatePicker extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            datePickerFocused: false,
            startDate: null,
            endDate: null
        };
        this.isClient = typeof window !== 'undefined';
    }

    setScrollRef = ele => {
        this.calRef = ele;
    };

    handleInputClick = event => {
        event.preventDefault();

        if (!this.state.datePickerFocused) {
            this.toggleCalendarFocus(true);
        }
    };

    handleOutsideClick = event => {
        let target = event.target;
        // find if whatever got clicked from the page is not
        // part of the calendar or the input boxes
        while (target && target.parentNode) {
            // if calendar or input clicked, don't do anything
            if (
                target.parentNode === this.calendar ||
                target === this.startInput ||
                target === this.endInput ||
                target.classList.contains(this.props.className)
            ) {
                return;
            }

            target = target.parentNode;
        }

        // clicked outside the calendar or input boxes
        this.toggleCalendarFocus(false);
    };

    removeEvent = () => {
        window.removeEventListener('click', this.handleOutsideClick);
    };

    addEvent = () => {
        setTimeout(() => {
            window.addEventListener('click', this.handleOutsideClick);
        }, 10);
    };

    handleInputFocus = event => {
        event.preventDefault();

        if (!this.state.datePickerFocused) {
            this.toggleCalendarFocus(true);
        }
    };

    handleSelectedDates = datesSelected => {
        this.setState({
            startDate: datesSelected.startDate,
            endDate: datesSelected.endDate
        });
    };

    handleStartDate = (event, date) => {
        this.setState({ startDate: date });
    };

    handleEndDate = (event, date) => {
        this.setState({ endDate: date });
    };

    toggleCalendarFocus = value => {
        this.setState({ datePickerFocused: value }, () => {
            if (value === true) {
                setTimeout(() => {
                    window.addEventListener('click', this.handleOutsideClick);
                }, 100);
            } else {
                window.removeEventListener('click', this.handleOutsideClick);
            }
        });
    };

    static propTypes = {
        startPlaceholder: PropTypes.string,
        endPlaceholder: PropTypes.string,
        className: PropTypes.string
    };

    static defaultProps = {
        startPlaceholder: 'Check-in',
        endPlaceholder: 'Check-out'
    };

    render() {
        const { state, handleInputClick, handleInputFocus, props, isClient } = this;
        const { startPlaceholder, endPlaceholder } = this.props;
        const { startDate, endDate, datePickerFocused } = state;
        const commonInputProps = {
            readOnly: 'readonly',
            onClick: handleInputClick,
            onFocus: handleInputFocus
        };
        let rootClassName = props.className;
        if (datePickerFocused && rootClassName) {
            rootClassName += ' pclnDatePickerFocused';
        }

        return (
            <div className={rootClassName}>
                <div className="pclnButtonAndInputsContainer">
                    <button type="button">
                        <Icon name="arrowLeft" color="white" size="24" />
                    </button>
                    <div className="pclnInputsContainer">
                        <Icon name="calendar" color="blue" size="16" className="calendarIcon" />
                        <input
                            {...commonInputProps}
                            ref={node => {
                                this.startInput = node;
                            }}
                            placeholder={startPlaceholder}
                            name="check_in"
                            value={startDate ? moment.utc(startDate).format('L') : ''}
                            onChange={event => this.handleStartDate(event, startDate)}
                            aria-label={startDate ? `Check-in: ${moment.utc(startDate).format('LL')}` : 'Select a check-in date'}
                        />
                        <div className={`inputSeperator${startDate ? ' inputSeperator__show' : ''}`} />
                        <input
                            {...commonInputProps}
                            ref={node => {
                                this.endInput = node;
                            }}
                            placeholder={endPlaceholder}
                            name="check_out"
                            value={endDate ? moment.utc(endDate).format('L') : ''}
                            onChange={event => this.handleEndDate(event, endDate)}
                            aria-label={endDate ? `Check-out: ${moment.utc(endDate).format('LL')}` : 'Select a check-out date'}
                            tabIndex="-1"
                        />
                    </div>
                </div>
                {isClient && (
                    // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
                    <div
                        className="pclnCalendarContainer"
                        ref={node => {
                            this.calendar = node;
                        }}
                        onClick={handleInputClick}
                        onKeyUp={handleInputClick}
                        onFocus={handleInputFocus}
                        role="application"
                    >
                        <Calendar
                            onChange={(event, datesSelected) => {
                                if (datesSelected.startDate && datesSelected.endDate) {
                                    this.toggleCalendarFocus(false);
                                }

                                this.handleSelectedDates(datesSelected);
                            }}
                            startDate={startDate}
                            endDate={endDate}
                            useDefaultFooter
                            onDismiss={() => this.toggleCalendarFocus(false)}
                            setCalenderRef={this.setScrollRef}
                        />
                    </div>
                )}
            </div>
        );
    }
}

export default withTheme(PricelineDatePicker);
